module.exports = __webpack_public_path__ + "img/画像匹配.86fdbce4.png";